export function formatPermissionOptions(data: any) {
  return data.map(item => ({
    id: item.label,
    label: item.label
  }));
}
